import React from "react";

class MetaPanel extends React.Component {
    render () {
        return (
            <div> Meta Panel</div>
        )
    }
};

export default MetaPanel;